export default "__VITE_ASSET__C$kXyaCf__"